export default __webpack_public_path__ + "static/media/man.d17a02ac.svg";